import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Footer.css';
import { Link } from 'react-router-dom';
import favicon from '../../assets/favicon.svg';
import logoPng from '../../assets/log01.png';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    const navigateAndScroll = () => {
      const section = document.querySelector(`[data-section="${sectionId}"]`);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    };

    if (location.pathname !== '/') {
      // If not on landing page, navigate and then scroll
      navigate('/', { replace: true });
      // Wait for navigation to complete
      setTimeout(navigateAndScroll, 100);
    } else {
      // If already on landing page, just scroll
      navigateAndScroll();
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section brand-section">
          <div className="footer-logo">
            <img src={favicon} alt="PrepKind Icon" className="footer-logo-icon" />
            <img src={logoPng} alt="PrepKind" className="footer-logo-text" />
          </div>
          <p>Empowering candidates with AI-powered interview preparation</p>
          <div className="social-links">
            <a href="#" className="social-link">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="https://www.linkedin.com/company/prepkind-com/" className="social-link">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="#" className="social-link">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
        
        <div className="footer-links-container">
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a onClick={() => scrollToSection('hero')} style={{ cursor: 'pointer' }}>Home</a></li>
              <li><a onClick={() => scrollToSection('features')} style={{ cursor: 'pointer' }}>Features</a></li>
              <li><a onClick={() => scrollToSection('howItWorks')} style={{ cursor: 'pointer' }}>How It Works</a></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><a onClick={() => scrollToSection('contact')} style={{ cursor: 'pointer' }}>Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Resources</h4>
            <ul>
              <li><Link to="/blog">Blog</Link></li>
              <li><a onClick={() => scrollToSection('howItWorks')} style={{ cursor: 'pointer' }}>Tutorials</a></li>
              <li><a onClick={() => scrollToSection('faq')} style={{ cursor: 'pointer' }}>FAQ</a></li>
              <li><a onClick={() => scrollToSection('contact')} style={{ cursor: 'pointer' }}>Support</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service">Terms of Service</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Us</h4>
            <ul className="contact-info">
              <li>
                <i className="fas fa-envelope"></i>
                <a href="mailto:support@prepkind.com">Contact@Prepkind.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} PrepKind. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
